import { app } from "../utils/store";

import GSAP from 'gsap';
import { each } from 'lodash';

class Cursor {
    create() {
        this.interactive = {
            links: document.querySelectorAll('a'),
            buttons: document.querySelectorAll('button'),
            // inputs: document.querySelectorAll('input'),
            carousels: document.querySelectorAll('[data-carousel]:not([data-carousel="only-mobile"])'),
            // modal_video: document.querySelectorAll('[data-modal-video]'),
            arrow: document.querySelectorAll('[data-arrow]'),
            cta: document.querySelectorAll('[data-cta]'),
            slide: document.querySelectorAll('[data-slide]'),
        }
        this.html = document.documentElement;

        if(!document.getElementById('cursor')){ this.createCursor() } // Create Cursor only if NOT exists
    }

    createCursor(){
        let cursor = document.createElement('div');
        cursor.id = 'cursor';
        cursor.setAttribute('data-label-default','');
        cursor.setAttribute('data-label','');

        this.html.append(cursor);

        this.followMouse(cursor);

        if(this.interactive.links){ this.hoverState(this.interactive.links); }
        if(this.interactive.buttons){ this.hoverState(this.interactive.buttons); }
        // if(this.interactive.inputs){ this.hoverState(this.interactive.inputs); }
        if(this.interactive.carousels){ this.hoverState(this.interactive.carousels); }
        // if(this.interactive.modal_video){ this.hoverState(this.interactive.modal_video); }
        if(this.interactive.arrow){ this.hoverState(this.interactive.arrow); }
        if(this.interactive.cta){ this.hoverState(this.interactive.cta); }
        if(this.interactive.slide){ this.hoverState(this.interactive.slide); }
    }

    followMouse = (element) => {
        GSAP.set(element, {
            xPercent: -50, 
            yPercent: -50
        });

        var position = { 
            x: window.innerWidth / 2, 
            y: window.innerHeight / 2 
        };

        var mouse = { 
            x: position.x,
            y: position.y 
        };

        var speed = 0.1;

        var fpms = 60 / 1000;

        var xSet = GSAP.quickSetter(element, "x", "px");
        var ySet = GSAP.quickSetter(element, "y", "px");

        window.addEventListener("mousemove", (event) => {
            mouse.x = event.x;
            mouse.y = event.y;  
        });

        GSAP.ticker.add((time, deltaTime) => {
            var delta = deltaTime * fpms;
            var dt = 1.0 - Math.pow(1.0 - speed, delta); 
            
            position.x += (mouse.x - position.x) * dt;
            position.y += (mouse.y - position.y) * dt;

            xSet(position.x);
            ySet(position.y);
        });
    }

    hoverState = (array) => {
        const cursor = document.getElementById('cursor');

        each(array, (entry, key) => {
            var elementLabel = entry.getAttribute('data-label');
            var isLink = entry.href != null;
            var isButton = entry.localName == 'button';
            var isDraggable = entry.hasAttribute('data-draggable');
            // var isCloser = entry.hasAttribute('data-modal-close');
            // var isModalVideo = entry.hasAttribute('data-modal-video');
            var isArrow = entry.hasAttribute('data-arrow');
            var isCta = entry.hasAttribute('data-cta');

            entry.addEventListener('mouseover', (e) => { 
                if(elementLabel){ cursor.setAttribute('data-label', elementLabel) }
                if(isDraggable){ 
                    cursor.classList.add('drag');
                    // cursor.setAttribute('data-label', 'Drag');
                }
                if(isArrow){ 
                    cursor.classList.add('arrow');
                }
                if(isLink || isButton){
                    e.stopPropagation()
                    cursor.classList.remove('arrow')
                    cursor.classList.remove('drag')
                }
                // if(isCloser || isModalVideo){ 
                //     cursor.classList.add('closer');
                //     cursor.setAttribute('data-label', '+');
                // }
                cursor.classList.add('active') 
            });

            entry.addEventListener('mouseleave', (e) => { 
                cursor.setAttribute('data-label', '')
                if(isArrow){ cursor.classList.remove('arrow') }
                if(isDraggable){ cursor.classList.remove('drag') }
                // if(isCloser || isModalVideo){ cursor.classList.remove('closer') }
                cursor.classList.remove('active')
                cursor.classList.remove('click')
            });

            entry.addEventListener('mousedown', (e) => { cursor.classList.add('click'); cursor.classList.remove('closer') });

            entry.addEventListener('mouseup', (e) => { cursor.classList.remove('click') });
        });
    }

    update = () => {
        this.interactive = {
            links: document.querySelectorAll('a'),
            // buttons: document.querySelectorAll('button, lottie-player'),
            // inputs: document.querySelectorAll('input'),
            carousels: document.querySelectorAll('[data-carousel]:not([data-carousel="only-mobile"])'),
            // modal_video: document.querySelectorAll('[data-modal-video]'),
            arrow: document.querySelectorAll('[data-next]'),
            cta: document.querySelectorAll('[data-cta]'),
            slide: document.querySelectorAll('[data-slide]'),
        }
        this.html = document.documentElement;

        if(this.interactive.links){ this.hoverState(this.interactive.links); }
        if(this.interactive.buttons){ this.hoverState(this.interactive.buttons); }
        // if(this.interactive.inputs){ this.hoverState(this.interactive.inputs); }
        if(this.interactive.carousels){ this.hoverState(this.interactive.carousels); }
        // if(this.interactive.modal_video){ this.hoverState(this.interactive.modal_video); }
        if(this.interactive.arrow){ this.hoverState(this.interactive.arrow); }
        if(this.interactive.cta){ this.hoverState(this.interactive.cta); }
        if(this.interactive.slide){ this.hoverState(this.interactive.slide); }
    }

    destroy = () => { 
        
    }
}

export const CursorManager = new Cursor();